import { ExternalLink } from 'lucide-react';
import type { UrlCitation } from '@/lib/streaming/types';

interface CitationsListProps {
  annotations: UrlCitation[];
}

function CitationsList({ annotations }: CitationsListProps) {
  if (!annotations || annotations.length === 0) return null;

  // Deduplicate by URL
  const seen = new Set<string>();
  const unique = annotations.filter((a) => {
    if (seen.has(a.url)) return false;
    seen.add(a.url);
    return true;
  });

  return (
    <div className="mt-3 pt-3 border-t border-gray-200">
      <p className="text-xs text-gray-500 mb-2 font-medium">Fonti</p>
      <div className="flex flex-wrap gap-2">
        {unique.map((citation) => (
          <a
            key={citation.url}
            href={citation.url}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1 px-2.5 py-1 text-xs bg-gray-50 border border-gray-200 rounded-md text-gray-700 hover:bg-gray-100 hover:border-gray-300 transition-colors max-w-[250px]"
            title={citation.title}
          >
            <ExternalLink className="h-3 w-3 shrink-0" />
            <span className="truncate">{citation.title || citation.url}</span>
          </a>
        ))}
      </div>
    </div>
  );
}

export default CitationsList;
